import { render, staticRenderFns } from "./UserSubscription.vue?vue&type=template&id=a56c3b52&scoped=true&"
import script from "./UserSubscription.vue?vue&type=script&lang=js&"
export * from "./UserSubscription.vue?vue&type=script&lang=js&"
import style0 from "./UserSubscription.vue?vue&type=style&index=0&id=a56c3b52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56c3b52",
  null
  
)

export default component.exports